var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "intercom"
  }, [_c('div', {
    staticClass: "intercomContent"
  }, [_c('div', {
    staticClass: "intrecomLeft"
  }, [_c('div', {
    staticClass: "groupBox"
  }, [_c('span', {
    staticClass: "groupTitle bold"
  }, [_vm._v(_vm._s(_vm.$t('intercom.session')))]), _c('span', {
    staticClass: "grayColor groupNumber"
  }, [_vm._v("(" + _vm._s(_vm.sessionList.length) + ")")]), _c('el-button', {
    staticClass: "createBtn",
    class: {
      active: _vm.noSessionSelectTalents.length && _vm.noSessionSelectStations.length
    },
    attrs: {
      "icon": "el-icon-plus",
      "disabled": !_vm.noSessionSelectTalents.length || !_vm.noSessionSelectStations.length
    },
    on: {
      "click": function ($event) {
        return _vm.createSession();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('intercom.createSession')) + " ")])], 1), _c('div', {
    staticClass: "groupContent"
  }, [_c('div', {
    staticClass: "groupHead"
  }, [_c('ul', [_c('li', {
    staticClass: "w_15"
  }, [_vm._v(_vm._s(_vm.$t('intercom.sessionName')))]), _c('li', {
    staticClass: "w_15"
  }, [_vm._v(_vm._s(_vm.$t('intercom.status')))]), _c('li', {
    staticClass: "w_15"
  }, [_vm._v(_vm._s(_vm.$t('intercom.station')))]), _c('li', {
    staticClass: "w_15"
  }, [_vm._v(_vm._s(_vm.$t('intercom.talent')))]), _c('li', {
    staticClass: "w_10"
  }, [_vm._v(_vm._s(_vm.$t('intercom.talkToTalent')))]), _c('li', {
    staticClass: "w_10"
  }, [_vm._v(_vm._s(_vm.$t('intercom.talkToSession')))]), _c('li', {
    staticClass: "w_10"
  }, [_vm._v(_vm._s(_vm.$t('intercom.speaker')))]), _c('li', {
    staticClass: "w_10"
  }, [_vm._v(_vm._s(_vm.$t('intercom.operation')))])])]), _c('div', {
    staticClass: "sessionList scrollbar"
  }, [_c('draggable', {
    on: {
      "change": _vm.changeSessionList
    },
    model: {
      value: _vm.sessionList,
      callback: function ($$v) {
        _vm.sessionList = $$v;
      },
      expression: "sessionList"
    }
  }, _vm._l(_vm.sessionList, function (item) {
    return _c('div', {
      key: item.intercomTabId,
      staticClass: "listLi",
      class: {
        active: _vm.selectSessionInfo.intercomSessionId == item.intercomSessionId
      },
      on: {
        "click": function ($event) {
          return _vm.saveSelectSessionInfo(item);
        }
      }
    }, [_c('span', {
      staticClass: "ellipsis w_15 text-indent-10"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !item.showRenameInput,
        expression: "!item.showRenameInput"
      }],
      staticClass: "pointer",
      attrs: {
        "title": item.sessionName
      },
      on: {
        "click": function ($event) {
          return _vm.showRenameInput(item);
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-tuozhuai grayColor m_r_10"
    }), _vm._v(" " + _vm._s(item.sessionName) + " ")]), item.showRenameInput ? _c('el-input', {
      ref: `${item.intercomSessionId}_input`,
      refInFor: true,
      on: {
        "blur": function ($event) {
          item.showRenameInput = false;
        },
        "change": val => {
          _vm.saveSessionName(val, item);
        }
      },
      model: {
        value: item.nameInputVal,
        callback: function ($$v) {
          _vm.$set(item, "nameInputVal", $$v);
        },
        expression: "item.nameInputVal"
      }
    }) : _vm._e()], 1), _c('span', {
      staticClass: "listSpan ellipsis w_15 pointer",
      class: {
        active: item.status,
        inActive: !item.status
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.controlActive(item);
        }
      }
    }, [item.status ? _c('span', {
      staticClass: "pointerSpan"
    }, [_vm._v("·")]) : _vm._e(), _vm._v(" " + _vm._s(item.status ? _vm.$t('intercom.active') : _vm.$t('intercom.inactive')) + " ")]), _c('span', {
      staticClass: "ellipsis w_15 text-indent-10 center",
      attrs: {
        "title": item.sessionStationsList.length ? _vm.nickNameMap[item.sessionStationsList[0].rtilCode] : ''
      }
    }, [_vm._v(_vm._s(item.sessionStationsList.length ? _vm.nickNameMap[item.sessionStationsList[0].rtilCode] : ''))]), _c('span', {
      staticClass: "ellipsis w_15 text-indent-10 center",
      attrs: {
        "title": _vm.returnTalentsName(item)
      }
    }, [_vm._v(_vm._s(_vm.returnTalentsName(item)))]), _c('span', {
      staticClass: "listSpan w_10",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return (() => {}).apply(null, arguments);
        }
      }
    }, [_c('span', {
      staticClass: "talkBtn",
      class: {
        active: item.sessionTalk
      },
      on: {
        "click": function ($event) {
          return _vm.controlSessionTalkToTalent(item);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('intercom.talk')) + " "), _c('div'), _c('div')])]), _c('span', {
      staticClass: "listSpan w_10",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return (() => {}).apply(null, arguments);
        }
      }
    }, [_c('span', {
      staticClass: "talkBtn",
      class: {
        active: item.pushToTalk
      },
      on: {
        "click": function ($event) {
          return _vm.contrlSessionTalk(item);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('intercom.talk')) + " "), _c('div'), _c('div')])]), _c('span', {
      staticClass: "listSpan ellipsis w_10 pointer",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.controlSessionSpeaker(item);
        }
      }
    }, [item.sessionSpeaker ? _c('i', {
      staticClass: "iconfont icon-a-speakeron"
    }) : _c('i', {
      staticClass: "iconfont icon-a-speakeroff"
    })]), _c('span', {
      staticClass: "listSpan ellipsis w_10 pointer"
    }, [_c('i', {
      staticClass: "iconfont icon-delete1",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.deleteSession(item);
        }
      }
    })])]);
  }), 0)], 1)])]), _c('div', {
    staticClass: "intercomRight"
  }, [_c('div', {
    staticClass: "talentModule"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "headerLeft"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('intercom.talent')))]), _c('span', {
    staticClass: "number grayColor"
  }, [_vm._v("(" + _vm._s(_vm.talentList.length) + ")")])]), _c('el-input', {
    staticClass: "headerSearch",
    attrs: {
      "size": "medium",
      "clearable": true,
      "prefix-icon": "el-icon-search",
      "placeholder": _vm.$t('intercom.searchPepole')
    },
    on: {
      "input": _vm.searchTalent,
      "clear": function ($event) {
        return _vm.showAllData('talent');
      }
    },
    model: {
      value: _vm.talentSearch,
      callback: function ($$v) {
        _vm.talentSearch = $$v;
      },
      expression: "talentSearch"
    }
  })], 1), _vm.talentList.length ? _c('div', {
    staticClass: "content"
  }, _vm._l(_vm.talentList, function (item) {
    return _c('div', {
      key: item.rtilCode,
      staticClass: "listItem pointer",
      on: {
        "click": function ($event) {
          return _vm.controlTalent(item);
        }
      }
    }, [item.deviceType === 'R' ? _c('el-popover', {
      attrs: {
        "popper-class": "IDTips",
        "trigger": "hover",
        "placement": "top",
        "visiable": true
      }
    }, [_c('nameItem', {
      attrs: {
        "slot": "reference",
        "rtc": _vm.rtc,
        "sessionList": _vm.sessionList,
        "speakerId": _vm.devicesInfo.speakerId,
        "sessionInfo": _vm.selectSessionInfo,
        "activeSpeakerInfo": _vm.activeSpeakerInfo,
        "deviceVoIPStatus": !!item.online,
        "nickName": _vm.nickNameMap[item.rtilCode],
        "singChannel": _vm.channels[item.rtilCode],
        "sessionSelect": _vm.returnTalentSelect(item),
        "createSelect": _vm.returnStationSelect(item, 'create')
      },
      on: {
        "callback": () => _vm.dealNameItemCalback(item)
      },
      slot: "reference"
    }), _c('div', {
      staticClass: "operationBox"
    }, [_c('div', {
      staticClass: "optionBoxLi"
    }, [_c('span', {
      staticClass: "dot liLeft",
      class: {
        offline: !_vm.returnStationStatus(item, 'device')
      }
    }), _c('span', {
      staticStyle: {
        "margin-right": "8px"
      }
    }, [_vm._v(_vm._s(_vm.$t('intercom.deviceVoIP')))]), _c('span', {
      class: {
        grayColor: !_vm.returnStationStatus(item, 'device')
      }
    }, [_vm._v(_vm._s(_vm.returnStationStatus(item, 'device') ? _vm.$t('intercom.on') : _vm.$t('intercom.off')))]), !_vm.returnStationStatus(item, 'device') ? _c('i', {
      staticClass: "iconfont icon-auto",
      on: {
        "click": function ($event) {
          return _vm.stationReJoin(item);
        }
      }
    }) : _vm._e()]), item.email ? _c('div', {
      staticClass: "optionBoxLi"
    }, [_c('i', {
      staticClass: "iconfont icon-touxiang liLeft"
    }), _c('span', [_vm._v(_vm._s(item.email))])]) : _vm._e(), item.email ? _c('div', {
      staticClass: "optionBoxLi"
    }, [_c('i', {
      staticClass: "iconfont icon-a-idID liLeft"
    }), _c('span', {
      class: {
        grayColor: _vm.returnUserID(item) == '-- --'
      }
    }, [_vm._v(_vm._s(_vm.returnUserID(item)))])]) : _vm._e()])], 1) : _c('nameItem', {
      attrs: {
        "slot": "reference",
        "rtc": _vm.rtc,
        "sessionList": _vm.sessionList,
        "speakerId": _vm.devicesInfo.speakerId,
        "sessionInfo": _vm.selectSessionInfo,
        "activeSpeakerInfo": _vm.activeSpeakerInfo,
        "nickName": _vm.nickNameMap[item.rtilCode],
        "singChannel": _vm.channels[item.rtilCode],
        "sessionSelect": _vm.returnTalentSelect(item)
      },
      on: {
        "callback": () => _vm.dealNameItemCalback(item)
      },
      slot: "reference"
    }), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: false,
        expression: "false"
      }]
    }, [_vm._v(_vm._s(item.rtilCode) + " - " + _vm._s(_vm.partyInfo.joinCode))])], 1);
  }), 0) : _c('div', {
    staticClass: "nodataBox scrollbar"
  }, [_c('p', {
    staticClass: "tips"
  }, [_c('span', {
    staticClass: "grayColor"
  }, [_vm._v(_vm._s(_vm.$t('intercom.click')))]), _c('span', {
    staticClass: "greenColor bold"
  }, [_vm._v("\"" + _vm._s(_vm.$t('intercom.copy')) + "\"")]), _c('span', {
    staticClass: "grayColor"
  }, [_vm._v(_vm._s(_vm.$t('intercom.buttonInvite')))]), _c('span', {
    staticClass: "whiteColor bold"
  }, [_vm._v(_vm._s(_vm.$t('intercom.partylineApp')))]), _c('span', {
    staticClass: "grayColor"
  }, [_vm._v(_vm._s(_vm.$t('intercom.users')))])]), _c('p', {
    staticClass: "tips"
  }, [_c('span', {
    staticClass: "grayColor"
  }, [_vm._v(_vm._s(_vm.$t('intercom.click')))]), _vm._m(0), _c('span', {
    staticClass: "grayColor"
  }, [_vm._v(_vm._s(_vm.$t('intercom.addPack')))])])])]), _c('el-divider', {
    staticClass: "intercomDivider"
  }), _c('div', {
    staticClass: "stationModule"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "headerLeft"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('intercom.station')))]), _c('span', {
    staticClass: "number grayColor"
  }, [_vm._v("(" + _vm._s(_vm.stationList.length) + ")")])]), _c('el-input', {
    staticClass: "headerSearch",
    attrs: {
      "size": "medium",
      "clearable": true,
      "prefix-icon": "el-icon-search",
      "placeholder": _vm.$t('intercom.searchStation')
    },
    on: {
      "input": _vm.searchStation,
      "clear": function ($event) {
        return _vm.showAllData('station');
      }
    },
    model: {
      value: _vm.stationSearch,
      callback: function ($$v) {
        _vm.stationSearch = $$v;
      },
      expression: "stationSearch"
    }
  })], 1), _vm.stationList.length ? _c('div', {
    staticClass: "content"
  }, _vm._l(_vm.stationList, function (item) {
    return _c('div', {
      key: item.rtilCode,
      staticClass: "listItem pointer",
      on: {
        "click": function ($event) {
          return _vm.controlStation(item);
        }
      }
    }, [_c('el-popover', {
      attrs: {
        "popper-class": "IDTips",
        "trigger": "hover",
        "placement": "top",
        "visiable": true
      }
    }, [_c('nameItem', {
      attrs: {
        "slot": "reference",
        "rtc": _vm.rtc,
        "index": _vm.returnSelectIndex(item),
        "deviceVoIPStatus": item.online,
        "sessionList": _vm.sessionList,
        "speakerId": _vm.devicesInfo.speakerId,
        "sessionInfo": _vm.selectSessionInfo,
        "activeSpeakerInfo": _vm.activeSpeakerInfo,
        "nickName": _vm.returnStationName(item),
        "singChannel": _vm.channels[item.rtilCode],
        "sessionSelect": _vm.returnStationSelect(item, 'session'),
        "createSelect": _vm.returnStationSelect(item, 'create')
      },
      on: {
        "callback": () => _vm.dealNameItemCalback(item)
      },
      slot: "reference"
    }), _c('div', {
      staticClass: "operationBox"
    }, [item.email ? _c('div', {
      staticClass: "optionBoxLi"
    }, [_c('span', {
      staticClass: "dot liLeft"
    }), _c('span', {
      staticStyle: {
        "margin-right": "8px"
      }
    }, [_vm._v(_vm._s(_vm.$t('intercom.webUi')))]), _c('span', {
      class: {
        grayColor: !_vm.returnStationStatus(item, 'web')
      }
    }, [_vm._v(_vm._s(_vm.returnStationStatus(item, 'web') ? _vm.$t('addTvuOne.online') : _vm.$t('addTvuOne.offline')))])]) : _vm._e(), _c('div', {
      staticClass: "optionBoxLi"
    }, [_c('span', {
      staticClass: "dot liLeft",
      class: {
        offline: !_vm.returnStationStatus(item, 'device')
      }
    }), _c('span', {
      staticStyle: {
        "margin-right": "8px"
      }
    }, [_vm._v(_vm._s(_vm.$t('intercom.deviceVoIP')))]), _c('span', {
      class: {
        grayColor: !_vm.returnStationStatus(item, 'device')
      }
    }, [_vm._v(_vm._s(_vm.returnStationStatus(item, 'device') ? _vm.$t('intercom.on') : _vm.$t('intercom.off')))]), !_vm.returnStationStatus(item, 'device') ? _c('i', {
      staticClass: "iconfont icon-auto",
      on: {
        "click": function ($event) {
          return _vm.stationReJoin(item);
        }
      }
    }) : _vm._e()]), item.email ? _c('div', {
      staticClass: "optionBoxLi"
    }, [_c('i', {
      staticClass: "iconfont icon-touxiang liLeft"
    }), _c('span', [_vm._v(_vm._s(item.email))])]) : _vm._e(), item.email ? _c('div', {
      staticClass: "optionBoxLi"
    }, [_c('i', {
      staticClass: "iconfont icon-a-idID liLeft"
    }), _c('span', {
      class: {
        grayColor: _vm.returnUserID(item) == '-- --'
      }
    }, [_vm._v(_vm._s(_vm.returnUserID(item)))])]) : _vm._e()])], 1), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: false,
        expression: "false"
      }]
    }, [_vm._v("rtilCode:" + _vm._s(item.rtilCode) + " - partyCode:" + _vm._s(_vm.partyInfo.joinCode))])], 1);
  }), 0) : _c('div', {
    staticClass: "nodataBox"
  }, [_c('p', {
    staticClass: "tips"
  }, [_c('span', {
    staticClass: "grayColor"
  }, [_vm._v(_vm._s(_vm.$t('intercom.click')))]), _vm._m(1), _c('span', {
    staticClass: "grayColor"
  }, [_vm._v(_vm._s(_vm.$t('intercom.addReceiver')))])])])])], 1)]), _c('intercomFoot', {
    attrs: {
      "rtc": _vm.rtc,
      "rtcLoaded": _vm.rtcLoaded,
      "mic": _vm.mic,
      "nickName": _vm.nickNameMap[_vm.partyInfo.rtilCode] || _vm.partyInfo.rtilCode,
      "speaker": _vm.speaker,
      "talentList": _vm.talentList,
      "rtilCode": _vm.partyInfo.rtilCode,
      "devicesInfo": _vm.devicesInfo,
      "microphoneDevice": _vm.devicesInfo.microphoneList,
      "speakerDevice": _vm.devicesInfo.speakerList,
      "selectSessionInfo": _vm.selectSessionInfo
    },
    on: {
      "eventCallback": _vm.footCallback
    }
  }), _vm.State.drawer ? _c('addPackReceiverJoin', {
    attrs: {
      "drawer": _vm.State.drawer,
      "partyCode": _vm.partyInfo.joinCode,
      "userInfo": {
        channelMode: 0
      },
      "channels": _vm.channels
    },
    on: {
      "close": function ($event) {
        _vm.State.drawer = false;
      }
    }
  }) : _vm._e(), _c('tipsDailog', {
    staticClass: "repeatJoin",
    attrs: {
      "width": "550px",
      "info": _vm.repeatInfo
    },
    on: {
      "save": function ($event) {
        _vm.repeatInfo.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('common.repeatContent')))])])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "whiteColor bold"
  }, [_vm._v("\""), _c('i', {
    staticClass: "iconfont icon-addDevice"
  }), _vm._v("\"")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "whiteColor bold"
  }, [_vm._v("\""), _c('i', {
    staticClass: "iconfont icon-addDevice"
  }), _vm._v("\"")]);
}];
export { render, staticRenderFns };